var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1200px",
    height: "1200px",
    viewBox: "0 0 1668.56 1221.19",
    style: {
      enableBackground: "new 0 0 1668.56 1221.19"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{stroke:#FFFFFF;stroke-miterlimit:10;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 834.28,
    cy: 610.6,
    r: 681.33
  }), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(52.390088,-25.058597)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1009",
    className: "st1",
    d: "M485.39,356.79l230.07,307.62L483.94,914.52h52.11l202.7-218.98l163.77,218.98h177.32 L836.82,589.6l215.5-232.81h-52.11L813.54,558.46L662.71,356.79H485.39z M562.02,395.17h81.46l359.72,480.97h-81.46L562.02,395.17 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/x-icon.a904ab3f8b895948b31a948b39fa25cd.svg";
export { ForwardRef as ReactComponent };